import React, { memo } from 'react';

import { twMerge } from 'tailwind-merge';

import Copy from '../Copy';

export type BadgeProps = {
  theme?:
    | 'white'
    | 'purple-dark'
    | 'purple'
    | 'primary'
    | 'danger'
    | 'danger-dark'
    | 'primary-dark'
    | 'info'
    | 'info-dark'
    | 'success'
    | 'success-dark'
    | 'warning'
    | 'warning-dark';
  text: React.ReactNode;
  className?: string;
};

const Badge = ({ theme = 'purple-dark', text, className }: BadgeProps) => {
  return (
    <div
      className={twMerge(
        'rounded-[12px] px-2 text-center',
        theme === 'purple' && 'bg-v2violet/20 text-v2violet',

        theme === 'purple-dark' &&
          'bg-v2violet drop-shadow-[0_2px_4px_rgba(110,80,255,0.2)] text-white',
        theme === 'primary' && 'bg-primary/20 text-primary',
        theme === 'info' && 'bg-v2blue-600/20 text-v2blue-600',
        theme === 'info-dark' && 'bg-v2blue-600 text-white',
        theme === 'success' && 'bg-v2green-300/20 text-v2green-300',
        theme === 'success-dark' && 'bg-v2green-300 text-white',
        theme === 'danger' && 'bg-v2red/20 text-v2red',
        theme === 'danger-dark' && 'bg-v2red text-white',
        theme === 'white' && 'bg-white text-v2blueGray-800',
        theme === 'warning' && 'bg-v2orange/20 text-v2orange',
        theme === 'warning-dark' && 'bg-v2orange text-white',
        theme === 'primary-dark' &&
          'bg-primary drop-shadow-[0px_2px_4px_rgba(75,180,179,0.2)] text-white',
        className,
      )}
    >
      <Copy noColor className="leading-[20px]" type="copy2" weight="medium">
        {text}
      </Copy>
    </div>
  );
};

export default memo<BadgeProps>(Badge);
